import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { updatePushNotificationsRequestModalHiddenTillDateAction } from 'actions/push/updatePushNotificationsRequestModalHiddenTillDateAction'
import {
  fetchNotificationsPermissionStatus,
  AppPermissionState,
} from 'api/browser/fetchPermissionStatus'
import { TimeRange } from 'common-constants/timeRange'
import { notificationsPushPath } from 'components/page/Settings/Settings.paths'
import { settingsModalPath } from 'components/paths'
import { isPureDevMode } from 'functions/isPureDevMode'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'

export const showPushNotificationsRequestModalIfNeededAction =
  () => async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const {
      pushNotifications: {
        pushNotificationsToken,
        pushNotificationsSupported,
        pushNotificationsRequestModalHiddenTillDate,
      },
      systemReducer: { baseUrl },
      authorizationReducer: { authorized, profile },
      userReducer: { hasDefaultPhoto },
      errorReducer: { gdprBlocked },
    } = getState()

    if (
      !authorized ||
      !profile?.isReal ||
      gdprBlocked ||
      !hasDefaultPhoto ||
      !pushNotificationsSupported ||
      pushNotificationsRequestModalHiddenTillDate > Date.now() ||
      isPureDevMode()
    ) {
      return
    }

    const permissionStatus = await fetchNotificationsPermissionStatus()
    const state = permissionStatus?.state

    if (!state) {
      return
    }

    if (
      state === AppPermissionState.Prompt ||
      /**
       * Так может быть, если юзер подключал пуши для другой анкеты.
       * Пермишн остался, а токена для новой анкеты нет.
       */
      (state === AppPermissionState.Granted && !pushNotificationsToken)
    ) {
      dispatch(updatePushNotificationsRequestModalHiddenTillDateAction())
      /**
       * С задержкой UX лучше:
       * 1. отправляешь сообщение
       * 2. Задержка
       * 3. Показывается модал подпишись на уведомления
       */
      setTimeout(() => {
        dispatch(
          push(mergeAllUrls(baseUrl, settingsModalPath, notificationsPushPath))
        )
      }, 2 * TimeRange.second)
    }
  }
